/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFPasswordCharacters
 */
export interface CRSFPasswordCharacters {
    /**
     * 
     * @type {number}
     * @memberof CRSFPasswordCharacters
     */
    lowercase: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFPasswordCharacters
     */
    numbers: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFPasswordCharacters
     */
    special: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFPasswordCharacters
     */
    uppercase: number;
}

/**
 * Check if a given object implements the CRSFPasswordCharacters interface.
 */
export function instanceOfCRSFPasswordCharacters(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lowercase" in value;
    isInstance = isInstance && "numbers" in value;
    isInstance = isInstance && "special" in value;
    isInstance = isInstance && "uppercase" in value;

    return isInstance;
}

export function CRSFPasswordCharactersFromJSON(json: any): CRSFPasswordCharacters {
    return CRSFPasswordCharactersFromJSONTyped(json, false);
}

export function CRSFPasswordCharactersFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPasswordCharacters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lowercase': json['lowercase'],
        'numbers': json['numbers'],
        'special': json['special'],
        'uppercase': json['uppercase'],
    };
}

export function CRSFPasswordCharactersToJSON(value?: CRSFPasswordCharacters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lowercase': value.lowercase,
        'numbers': value.numbers,
        'special': value.special,
        'uppercase': value.uppercase,
    };
}

